export default __webpack_public_path__ + "static/media/prbicon_PredictYourDeadline.d4b93f4b.svg";